export default __webpack_public_path__ + "static/media/IMG-6712 (1) (1) - Jerusha Serena.285538ba.jpg";